import Vue from "modules/vue_twemoji";
import VueI18n from "vue-i18n";
import SqlReference from "components/sql-reference";

Vue.use(VueI18n);

const $container = document.querySelector(".js-sql-reference");

if($container) {
  new Vue({
    el: $container,
    render: h => h(SqlReference),
    i18n: new VueI18n({
      locale: "en"
    })
  });
}
